var map = {
	"./Estrategia.png": 3533,
	"./Notario_Dedica.jpg": 9516,
	"./OpenSource.jpg": 9515,
	"./Universities/IEST.jpg": 7114,
	"./Universities/ITDPDA.png": 7324,
	"./Universities/ITDZ.png": 5877,
	"./Universities/ITEL.png": 1641,
	"./Universities/ITP.jpg": 8680,
	"./Universities/ITSNa.jpg": 7719,
	"./Universities/ITSON.png": 1431,
	"./Universities/ITSSAT.jpg": 2223,
	"./Universities/ITZ.jpg": 3012,
	"./Universities/TM.png": 4095,
	"./Universities/TS.jpg": 7529,
	"./Universities/UAG.jpg": 4311,
	"./Universities/UAZ.png": 7036,
	"./Universities/UDG.jpeg": 3556,
	"./Universities/UNIR.png": 9469,
	"./Universities/UPA.jpg": 7617,
	"./Universities/UPZ.jpg": 8670,
	"./Universities/UT.jpg": 2691,
	"./Universities/UTH.jpg": 6968,
	"./Universities/UTM.jpg": 6153,
	"./Universities/UTN.jpg": 3013,
	"./Universities/UTNA.jpg": 3178,
	"./Universities/UTR.jpg": 3815,
	"./Zacatecas3.jpg": 6899,
	"./academy.jpeg": 5589,
	"./city.jpg": 412,
	"./dedicalogo.png": 5579,
	"./eventoLOTS/Abraham.jpeg": 5322,
	"./eventoLOTS/Adlair.jpeg": 7274,
	"./eventoLOTS/Alonso López.jpeg": 5406,
	"./eventoLOTS/Argel.jpeg": 9278,
	"./eventoLOTS/Hector.jpeg": 3389,
	"./eventoLOTS/Isaac.jpeg": 1925,
	"./eventoLOTS/Ivan.jpeg": 784,
	"./eventoLOTS/Luis.jpg": 4098,
	"./eventoLOTS/Manuel.jpeg": 4403,
	"./eventoLOTS/Ramón Morales.jpg": 4955,
	"./eventoLOTS/Rubén.jpeg": 2701,
	"./eventoLOTS/cartel.jpeg": 7285,
	"./eventoLOTS/cartel2.jpeg": 2497,
	"./eventoLOTS/claudio.jpeg": 6844,
	"./eventoLOTS/daniel.jpeg": 2135,
	"./eventoLOTS/miguel.jpeg": 4748,
	"./eventoLOTS/oscar.jpeg": 6537,
	"./eventoLOTS/ruben.jpeg": 4840,
	"./eventoLOTS/samuel.jpeg": 4747,
	"./eventos/4lentes.jpg": 7507,
	"./eventos/GNOME.png": 7628,
	"./eventos/GNOME2.png": 6870,
	"./eventos/OSTT.jpg": 1967,
	"./eventos/ambassadors.jpg": 8873,
	"./eventos/flisol2023.jpg": 2039,
	"./eventos/innova.jpeg": 5464,
	"./eventos/lots.jpg": 5872,
	"./eventos/lots2.jpg": 2449,
	"./gnome.png": 4684,
	"./icon-mas.png": 4691,
	"./iconos/img-correo.svg": 3665,
	"./iconos/img-estadisticas.svg": 5784,
	"./iconos/img-linkedin.svg": 3215,
	"./iconos/img-twitter.svg": 7431,
	"./iconos/img-usuario.svg": 9990,
	"./iconos/male_avatar.svg": 6547,
	"./jovenes.jpg": 6069,
	"./know_your_costumer.png": 5865,
	"./landscape.jpeg": 4516,
	"./learn_startup.png": 7986,
	"./liderazgo.jpg": 3199,
	"./macedonia.jpeg": 2113,
	"./mapa_mundial.svg": 8636,
	"./mar2.jpg": 8946,
	"./miembros/Manuel.jpeg": 6501,
	"./miembros/Ramón Morales.jpg": 7141,
	"./miembros/oscar.jpeg": 1715,
	"./modal-popup.jpeg": 5632,
	"./opensourcelogo.png": 9717,
	"./portada_1.jpg": 4330,
	"./talento.jpg": 6940,
	"./trees.jpeg": 3954,
	"./ubicacion/ubicacion.png": 1303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;